import { render, staticRenderFns } from "./ProviderInformation2.vue?vue&type=template&id=a3ba87f6&lang=pug&"
import script from "./ProviderInformation2.vue?vue&type=script&lang=js&"
export * from "./ProviderInformation2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProviderInformation2.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
installComponents(component, {
  VDivider,
})
